<div class="content p-4 w-full h-full overflow-auto">
  <div>
    <pre class="hljs p-4">{{eventMessagesService.eventStack|json}}</pre>
  </div>
</div>
